import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent, TypographyComponent } from '@hyperkit';

import { PivotItemSource } from '../capture-data-dialog.component';

@Component({
  selector: 'pivot-card',
  standalone: true,
  imports: [CommonModule, TypographyComponent, ButtonComponent],
  templateUrl: './pivot-card.component.html',
  styleUrls: ['./pivot-card.component.scss']
})
export class PivotCardComponent {
  @Input() title = '';
  @Input() description = '';
  @Input() selected = false;
  @Input() source?: PivotItemSource;

  @Output() pivotSelection = new EventEmitter<void>();

  onToggleSelection(): void {
    this.pivotSelection.emit();
  }

  getSourceLabelParts(source: PivotItemSource | undefined): { icon: string, text: string } {
    switch (source) {
      case 'demo':
        return { icon: '🧪', text: 'Demo' };
      case 'recommended':
        return { icon: '⭐', text: 'Recommended' };
      case 'auto':
        return { icon: '🤖', text: 'Dynamic' };
      default:
        return { icon: '', text: '' };
    }
  }
}
